import React from 'react'

const SidebarToggler = ({ text = "Table of Contents" }) => {
    return (
        <a href="#" className="d-md-none" data-bs-toggle="offcanvas" data-bs-target="#sidebar">{text}</a>
    )
}
export default SidebarToggler;
